import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTermLife from './en/termLife.json';
import enTermCancer from './en/termCancer.json';
import enMedSecure from './en/medSecure.json';
import enShared from './en/shared.json';
import enCommon from './en/common.json';
import enB40 from './en/b40.json';
import enDisability from './en/disability.json';
import enKlook from './en/klook.json';
import msShared from './ms/shared.json';
import msCommon from './ms/common.json';
import msB40 from './ms/b40.json';
import enBig3Product from './en/big3Product.json';
import enTelemarketing from './en/telemarketing.json';
import enEPF from './en/epf.json';
import enEPP from './en/epp.json';
import msEPF from './ms/epf.json';
import enWheel from './en/wheel.json';
import enSpecialMed from './en/specialMed.json';
import enmedicalProduct from './en/medicalProduct.json';
import enmcPlus from './en/mcPlus.json';
import msmcPlus from './ms/mcPlus.json';
import msEPP from './ms/epp.json';

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  debug: false,
  interpolation: {
    escapeValue: false
  },
  resources: {
    en: {
      shared: enShared,
      common: enCommon,
      termLife: enTermLife,
      termCancer: enTermCancer,
      medSecure: enMedSecure,
      b40: enB40,
      disability: enDisability,
      big3Product: enBig3Product,
      telemarketing: enTelemarketing,
      epf: enEPF,
      epp: enEPP,
      wheel: enWheel,
      klook: enKlook,
      specialMed: enSpecialMed,
      medicalProduct: enmedicalProduct,
      mcPlus: enmcPlus
    },
    ms: {
      shared: msShared,
      common: msCommon,
      b40: msB40,
      epf: msEPF,
      epp: msEPP,
      mcPlus: msmcPlus
    }
  }
});

export default i18n;
